import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { PlantService, PlantTypeService, SpeciesGroupService } from 'cbd-proxies';

FieldBuilder.setNamespace('Operational');

export const OFFICIALPLANNEDPLANTATIONPLANT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('consumableCode', 'Entity.OfficialPlannedPlantationPlant.ConsumableCode')
    .readOnly()
    .build(),
  FieldBuilder.foreignKey(
    'plantId',
    'Entity.Plant',
    PlantService
  )
    .queryFilter({ consumableTypeName: 'Plantas' })
    .display('consumable.code')
    .loadWith((service, query, config) => {
      if (Array.isArray(query.id) && query.id.length) {
        return service.getListByIds({ ids: query.id.map(Number) }, config);
      }

      return service.getList({
        skipCount: query.skipCount,
        maxResultCount: query.maxResultCount,
        sorting: query.sorting,
        consumableTypeName: 'Plantas',
        consumableCode: query['consumable.code'] as string | undefined,
      }, config);
    })
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'plantTypeId',
    'Entity.PlantType',
    PlantTypeService
  )
    .display('name')
    .displayFromNested('plantTypeName')
    .sortBy('plantTypeName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'speciesGroupId',
    'Entity.SpeciesGroup',
    SpeciesGroupService
  )
    .required()
    .display('name')
    .displayFromNested('speciesGroupName')
    .sortBy('speciesGroupName')
    .keyField('id')
    .build(),
];

export const OFFICIALPLANNEDPLANTATIONPLANT_CONFIG = {
  entityName: 'OfficialPlannedPlantationPlant',
  localizationKey: 'Operational::Entity.OfficialPlannedPlantationPlant',
  fields: OFFICIALPLANNEDPLANTATIONPLANT_FIELDS,
  permission: 'PlanningOperation.OfficialPlannedPlantationPlants',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
};
